var map = {
	"./covidapp.jpg": 6689,
	"./icon-link/app-store.svg": 8839,
	"./icon-link/github.png": 283,
	"./icon-link/play-store.svg": 5812,
	"./icon-link/web.svg": 3868,
	"./jellylist.png": 329,
	"./nowchassprject.png": 2553,
	"./nowgameproject.png": 3956,
	"./portfolio-1.jpg": 5303,
	"./portfolio-4.jpg": 6574,
	"./portfolio-project.png": 8521,
	"./projects-data": 2279,
	"./projects-data.json": 2279,
	"./scrumpoker.png": 6352
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2353;